import { render, staticRenderFns } from "./AddLabelDialog.vue?vue&type=template&id=0a9e041e&scoped=true"
import script from "./AddLabelDialog.vue?vue&type=script&lang=js"
export * from "./AddLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./AddLabelDialog.vue?vue&type=style&index=0&id=0a9e041e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e041e",
  null
  
)

export default component.exports